import { Store, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Merchants() {
    const merchants = [
        {
            name: 'Quick Cash - Bole Branch',
            address: 'Bole Road, Near Edna Mall, Addis Ababa',
            phone: '+251 11 662 1234'
        },
        {
            name: 'Money Express - Merkato',
            address: 'Merkato Area, Addis Ababa',
            phone: '+251 11 551 5678'
        },
        {
            name: 'Fast Transfer - Piazza',
            address: 'Piazza District, Addis Ababa',
            phone: '+251 11 552 9876'
        },
        {
            name: 'Swift Money - Megenagna',
            address: 'Megenagna, CMC Road, Addis Ababa',
            phone: '+251 11 663 4567'
        },
        {
            name: 'Instant Cash - 4 Kilo',
            address: '4 Kilo, Near University, Addis Ababa',
            phone: '+251 11 551 2345'
        },
        {
            name: 'Global Money - Mexico',
            address: 'Mexico Square, Addis Ababa',
            phone: '+251 11 552 8901'
        },
        {
            name: 'Prime Transfer - Gerji',
            address: 'Gerji, Mebrat Haile Road, Addis Ababa',
            phone: '+251 11 664 3456'
        },
        {
            name: 'Reliable Cash - Kazanchis',
            address: 'Kazanchis Business District, Addis Ababa',
            phone: '+251 11 551 7890'
        }
    ];

    return (
        <div className="min-h-screen pt-24 pb-20">
            <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-5xl font-bold mb-6">
                            Our Trusted Merchants
                        </h1>
                        <p className="text-xl text-emerald-50 mb-8">
                            Find convenient locations to send or receive money across Ethiopia through our network of trusted merchant partners.
                        </p>
                        <Link to="/contact" className="inline-block bg-yellow-500 text-emerald-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition transform hover:scale-105">
                            Become a Merchant Partner
                        </Link>
                    </div>
                </div>
            </section>

            <section className="py-12 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {merchants.map((merchant, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition transform hover:scale-105">
                                <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-emerald-50 to-yellow-50">
                                    <div className="flex items-center gap-3">
                                        <div className="bg-emerald-800 p-3 rounded-lg">
                                            <Store className="w-6 h-6 text-white" />
                                        </div>
                                        <h3 className="text-xl font-bold text-emerald-900">{merchant.name}</h3>
                                    </div>
                                </div>

                                <div className="p-6 space-y-4">
                                    <div className="flex items-start gap-3">
                                        <MapPin className="w-5 h-5 text-emerald-800 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-700">Address</p>
                                            <p className="text-gray-600">{merchant.address}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <Phone className="w-5 h-5 text-emerald-800 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-700">Phone</p>
                                            <a href={`tel:${merchant.phone}`} className="text-emerald-800 hover:text-emerald-600 transition font-semibold">
                                                {merchant.phone}
                                            </a>
                                        </div>
                                    </div>

                                    <button className="w-full mt-4 bg-emerald-800 text-white px-4 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition">
                                        View on Map
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-12 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto">
                        <div className="bg-gradient-to-br from-emerald-50 to-yellow-50 p-12 rounded-2xl shadow-xl">
                            <h2 className="text-3xl font-bold text-emerald-900 mb-6 text-center">
                                Interested in Becoming a Merchant?
                            </h2>
                            <p className="text-lg text-gray-700 mb-8 text-center">
                                Join our growing network of trusted merchants and offer money transfer services to your community.
                            </p>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                                <div className="text-center">
                                    <div className="bg-emerald-800 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                                        1
                                    </div>
                                    <h3 className="font-bold text-emerald-900 mb-2">Register</h3>
                                    <p className="text-gray-600">Fill out the merchant application form</p>
                                </div>
                                <div className="text-center">
                                    <div className="bg-emerald-800 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                                        2
                                    </div>
                                    <h3 className="font-bold text-emerald-900 mb-2">Verify</h3>
                                    <p className="text-gray-600">Complete verification and training</p>
                                </div>
                                <div className="text-center">
                                    <div className="bg-emerald-800 text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                                        3
                                    </div>
                                    <h3 className="font-bold text-emerald-900 mb-2">Start Earning</h3>
                                    <p className="text-gray-600">Begin serving customers and earn commissions</p>
                                </div>
                            </div>

                            <div className="text-center">
                                <Link to="/contact" className="inline-block bg-emerald-800 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-emerald-700 transition transform hover:scale-105">
                                    Apply to Become a Merchant
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
